import { render, staticRenderFns } from "./OrderCreateStep2.vue?vue&type=template&id=18f9e949&"
import script from "./OrderCreateStep2.vue?vue&type=script&lang=js&"
export * from "./OrderCreateStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports